type TranslateFn = (key: string, options?: Record<string, string | number>) => string

function parseHmsDuration(value: string): { totalHours: number; minutes: number } | null {
  const trimmed = value.trim()
  const withSeconds = /^(\d+):(\d{2}):(\d{2})$/.exec(trimmed)
  const match = withSeconds ?? /^(\d+):(\d{2})$/.exec(trimmed)
  if (!match) return null

  const totalHours = parseInt(match[1], 10)
  const minutes = parseInt(match[2], 10)
  if (minutes >= 60 || Number.isNaN(totalHours) || Number.isNaN(minutes)) return null

  return { totalHours, minutes }
}

/** Formats TwelveData HH:MM:SS duration for tooltips — no seconds; days when >= 24h. */
export function formatTimeToOpenForTooltip(t: TranslateFn, raw: string | null | undefined): string {
  const parsed = parseHmsDuration(raw?.trim() || '00:00:00')
  if (!parsed) return '00:00'

  const { totalHours, minutes } = parsed
  const hh = String(totalHours % 24).padStart(2, '0')
  const mm = String(minutes).padStart(2, '0')

  if (totalHours >= 24) {
    const days = Math.floor(totalHours / 24)
    return t('tradeList.marketTimeDaysHours', { days, time: `${hh}:${mm}` })
  }

  return `${String(totalHours).padStart(2, '0')}:${mm}`
}
